import { makeStyles } from '@mui/styles';

const SightStyles = makeStyles(() => ({
	screen: {
		backdropFilter: 'blur(3px)',
		background: '#0000003d',
		position: 'fixed',
		width: '100%',
		height: '100vh',
		top: 0,
		left: 0,
		zIndex: 2001,
	},
	graphic: {
		height: '100%',
		width: '100%',
	},
	picture: {
		margin: 'auto',
		display: 'block',
		marginTop: '350px',
		width: '153px',
		height: '84px',
		opacity: 1,
	},

	paragraph: {
		color: '#FFFFFF',
		margin: '30px',
		padding: 0,
		fontSize: '25px',
		textAlign: 'center',
		fontFamily: 'Montserrat',
		fontWeight: '700',
		letterSpacing: 0,
		opacity: 1,
	},
}));

export default SightStyles;
